import { gql } from '@apollo/client';

import { loggedUserData, invitationDetailsData, invitationDocumentData, invitationData, invitationMetadataData } from './fragments';

export const CURRENT_USER = gql`
  query {
    me {
      ...LoggedUserData
    }
  }
  ${loggedUserData}
`;

// Attachments already uploaded for a category — used by the interview media
// checklist to mark items done (e.g. on reload).
export const GET_CATEGORY_ATTACHMENTS = gql`
  query GetCategoryAttachments($categoryId: ID!) {
    getCategoryAttachments(categoryId: $categoryId) {
      _id
      fileName
      s3Key
      contentType
      fileSize
      uploadedAt
      requestKey
    }
  }
`;

export const VALIDATE_INVITATION = gql`
  query ValidateInvitation($token: String!) {
    validateInvitation(token: $token) {
      success
      action
      message
      statusCode
      currentUser {
        id
        email
        isAuthenticated
        isAnonymous
      }
      invitation {
        ...InvitationDetailsData
    
      }
      document {
        ...InvitationDocumentData
      }
    }
  }
  ${invitationDetailsData}
  ${invitationDocumentData}
`;

export const GET_INVITATION_INFO = gql`
  query GetInvitationInfo($token: String!) {
    getInvitationInfo(token: $token) {
      success
      message
      statusCode
      invitation {
        ...InvitationDetailsData
      }
      document {
        ...InvitationDocumentData
      }
    }
  }
  ${invitationDetailsData}
  ${invitationDocumentData}
`;

export const GET_USER_INVITATIONS = gql`
  query GetUserInvitations($input: UserInvitationsInput!) {
    getUserInvitations(input: $input) {
      success
      statusCode
      invitations {
        ...InvitationData
      }
      pagination {
        page
        limit
        total
        pages
      }
    }
  }
  ${invitationData}
`;

// Fragment for inbox interview fields
export const inboxInterviewFields = gql`
  fragment InboxInterviewFields on InboxInterview {
    _id
    proxiId
    proxiCastId
    circleId
    status
    createdAt
    expiresAt
    invitationToken
    interviewType
    isMarketplace
    marketplaceStatus
    seriesId
    marketplaceInstructions
    marketplaceReward
    inviterId
    isNewMemberWelcome
    inviter {
      _id
      personalData {
        firstName
        lastName
        email
        avatar
      }
    }
    series {
      _id
      seriesTitle
      seriesSummary
      defaults {
        episodeImageUrl
      }
    }
    proxiCast {
      _id
      episodeName
      context
      interviewEnd
      status
      episodeImageUrl
      seriesId
    }
    circle {
      _id
      name
      avatarPhoto
    }
  }
`;

export const GET_MY_INBOX_INTERVIEWS = gql`
  query GetMyInboxInterviews($pagination: PaginationInput) {
    getMyInboxInterviews(pagination: $pagination) {
      items {
        ...InboxInterviewFields
      }
      totalCount
      hasMore
    }
  }
  ${inboxInterviewFields}
`;

export const GET_SELF_INTERVIEW_CHECK_IN = gql`
  query GetSelfInterviewCheckIn($interviewId: String!) {
    getSelfInterviewCheckIn(interviewId: $interviewId) {
      code
      success
      error
      categoryId
      topicName
      selfInterviewName
      isArchive
      game
    }
  }
`;

export const GET_MY_CIRCLES = gql`
  query GetMyCircles {
    getMyCircles {
      _id
      name
      avatarPhoto
      description
      circleAdminId
    }
  }
`;

export const CREATE_NEWS_TIP_INTERVIEW = gql`
  mutation CreateNewsTipInterview($input: CreateNewsTipInterviewInput!) {
    createNewsTipInterview(input: $input) {
      code
      success
      error
      inviteToken
      category {
        _id
        name
      }
      interview {
        _id
        status
      }
      proxiCast {
        _id
        episodeName
      }
    }
  }
`;

/** A Backstory item's link: short-lived, signed for the signed-in family member. */
export const GET_CIRCLE_MEDIA_URL = gql`
  query GetCircleMediaUrl(
    $circleId: String!
    $sourceType: CircleMediaSourceType!
    $sourceId: String!
  ) {
    getCircleMediaUrl(circleId: $circleId, sourceType: $sourceType, sourceId: $sourceId) {
      success
      downloadUrl
      error
    }
  }
`;
